import React from "react";

const LanguageContext = React.createContext({
  currentLanguage: 0,
  setCurrentLanguage: ()=>{},
});

export default LanguageContext;
